import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import BaseController from '../../../BaseController';
import { FragmentNames, HealthHistoryDiseasesListAliases } from '../../../../codegen';
import { ApplicationRoute } from '../../../../constants/routes';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { HealthHistoryListContext } from '../../service/health-history-list-service';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { Inject } from '@odinjs/odin';

@Controller ({ component: HealthHistoryDiseasesListAliases.LAYOUT_HEALTH_HISTORY_DISEASES_LIST, fragment: FragmentNames.HEALTH_HISTORY_DISEASES_LIST })
export default class HealthHistoryAllergiesListController extends BaseController {

  @Inject(HealthHistoryDiseasesListAliases.PANEL_HEALTH_HISTORY_DISEASES)
  private panelHealthHistoryDiseasesAPI!: PanelAPI;

  @OnMount(HealthHistoryDiseasesListAliases.LAYOUT_HEALTH_HISTORY_DISEASES_LIST)
  handleMountLayoutAllergiesList(): void {
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    this.panelHealthHistoryDiseasesAPI.setVisible(allowInfo);
  }

  @OnClick({ target: HealthHistoryDiseasesListAliases.BUTTON_ADD_HEALTH_HISTORY_DISEASES })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    applicationContext.redirect(
      ApplicationRoute.HEALTH_HISTORY_DISEASES_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: HealthHistoryDiseasesListAliases.DECK_HEALTH_HISTORY_DISEASES })
  handleOnClickCard(event: ClickEvent): void {
    const { idHealthHistory, releaseDate } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    const accessViewer = releaseDate || !allowInfo;
    const route = accessViewer ? ApplicationRoute.HEALTH_HISTORY_DISEASES_VIEWER : ApplicationRoute.HEALTH_HISTORY_DISEASES_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idHealthHistory,
      patientId,
    });
  }
}
